import type { ReactElement } from 'react';

const Accesibilidad = (): ReactElement => (
	<div className="p-legal">
		<h1 className="p-legal__tit">Accesibilidad</h1>
		<article className="[ u-flow ] u-mt-24">
			<p>
				El CONSEJO GENERAL DEL NOTARIADO en línea con su compromiso por favorecer la integración de las
				personas con discapacidad, incluyendo a personas con minusvalías físicas o cognitivas, e
				independientemente de los dispositivos tecnológicos empleados para acceder a la información ha
				trabajado conforme a las Directrices de Accesibilidad definidas por el grupo de trabajo permanente
				Web Accessibility Initiative (WAI), del Consorcio para la World Wide Web (W3C).
			</p>
			<p>
				El sitio de Portal Notarial de la Banca ha sido desarrollado utilizando XHTML (eXtensible Hypertext
				Markup Language)y hojas de estilo cumpliendo, en la medida de lo posible, con las validaciones XHTML
				1.0 y CSS (Cascading Style Sheets) del W3C.
			</p>
			<p>
				Entre las principales medidas adoptadas para garantizar la accesibilidad, se encuentran las
				siguientes:
			</p>
			<ul>
				<li>
					Tamaño del texto. Las fuentes utilizadas tienen dimensiones relativas, de forma que el usuario
					puede controlar su tamaño desde el navegador que esté utilizando.
				</li>
				<li>
					Diseño, navegación e interactividad. Se ha tratado de conseguir una navegación coherente en todo
					el sitio web, siguiendo los mismos esquemas estructurales en todas las páginas.
				</li>
			</ul>
			<p>El Portal Notarial de Empresas y Profesionales se encuentra disponible para los siguientes navegadores:</p>
			<ul className="o-list o-list--bullet">
				<li>Chrome</li>
				<li>Firefox</li>
				<li>Microsoft Edge</li>
				<li>Safari</li>
			</ul>
			<p>Puedes acceder utilizando un PC, Mac, móvil o tableta.</p>
		</article>
	</div>
);

export default Accesibilidad;
